import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContratoService } from 'src/app/services/contrato/contrato.service';
import { DadosBase, DadosBaseService } from 'src/app/services/dados-base/dados-base.service';
import { ConsultarTermoFidelidade } from 'src/models/interfaces/contrato/contrato.interface';
import { base64ToBlob } from 'src/utils/blob';
import { HomeComponent } from '../../home/home.component';

@Component({
  selector: 'spe-area-restrita',
  templateUrl: './area-restrita.component.html',
  styleUrls: ['./area-restrita.component.scss'],
  standalone: false
})
export class AreaRestritaComponent implements OnInit {
  apiStatus: string | null = null;
  message: string = '';
  public isCaixa = localStorage.getItem('sigla') == 'CAIXA';
  listToDo: boolean[] = [true, true, true, true, false, false, false, false];
  listaDados: DadosBase = {
    beneficios: 0,
    cargos: 0,
    contatos: 0,
    departamentos: 0,
    enderecos: 0,
    funcionarios: 0,
    turnos: 0
  };
  showAvisoTermosDeContrato: boolean = false;
  termosFidelidade: ConsultarTermoFidelidade[] = [];
  public screenWidth!: number;
  public screenHeight!: number;

  constructor(
    private readonly routerService: Router,
    private dadosBaseService: DadosBaseService,
    private contratoService: ContratoService,
    private homeComponent: HomeComponent
  ) {}

  ngOnInit(): void {
    this.homeComponent.menuName = '';
    const pedidos = localStorage.getItem('pedidos');
    if (pedidos && parseInt(pedidos) > 0) {
      this.routerService.navigate(['home/quadro-de-avisos/inicial']);
    } else {
      this.getDadosBase();
      this.getTermosFidelidade();
    }
  }

  getDadosBase() {
    this.dadosBaseService.getAll().subscribe((dados: DadosBase) => {
      this.listaDados = dados;
    });
  }

  navigateTo = (path: string = '') => {
    this.routerService.navigate([`/home/${path}`]);
  };

  getTermosFidelidade() {
    this.contratoService.consultarTermosFidelidade().subscribe({
      next: (response) => {
        this.termosFidelidade = response;
        if (response.length > 0) {
          this.showAvisoTermosDeContrato = true;
        }
      }
    });
  }

  openTermoFidelidade() {
    this.termosFidelidade.forEach((item) => {
      this.contratoService.getById(item.idTipoContrato, item.flagInclusaoManual, 'S').subscribe({
        next: (response) => {
          const mimeType = 'application/pdf';
          const blob = base64ToBlob(response.contrato.documentoAnexo ?? response.contrato.textoContrato, mimeType);
          const baseUrl = window.location.origin;
          const fileURL = URL.createObjectURL(blob!);
          const title = `Termos_de_fidelidade.pdf`;
          const pdfViewerUrlWithParam = `${baseUrl}/pdf-viewer?pdf=${encodeURIComponent(fileURL)}&title=${title}`;
          window.open(pdfViewerUrlWithParam);
        }
      });
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.getScreenSize();
  }

  getScreenSize() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }
}
